import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { rem } from '@bonusly/ds-utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

export const Checkbox = defineMultiStyleConfig({
	baseStyle: {
		control: {
			borderRadius: rem(6),
			position: 'relative',
			top: rem(2),
			w: 5,
			h: 5,
		},
	},
	variants: {
		circle: {
			control: {
				borderRadius: 'full',
			},
		},
	},
});
